import { useState, useEffect } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, PieChart, Pie, Cell, CartesianGrid } from "recharts";

export default function LiveDashboardWebSocket() {
  const [data, setData] = useState({
    events: [], reportDefs: [], groups: [], members: [], groupMembers: [], reportGroups: []
  });

  useEffect(() => {
    const ws = new WebSocket(process.env.REACT_APP_WS_URL);
    ws.onmessage = (event) => setData(JSON.parse(event.data));
    return () => ws.close();
  }, []);

  const { events, reportDefs, groups, members, groupMembers, reportGroups } = data;

  const buttonCounts = {};
  const reportCounts = {};
  const groupCounts = {};
  events.forEach(e=>{
    buttonCounts[e.button_id]=(buttonCounts[e.button_id]||0)+1;
    const def=reportDefs.find(r=>r.serial===e.serial && r.button_id===e.button_id);
    const reportText = def ? def.report_text : "No Report";
    reportCounts[reportText]=(reportCounts[reportText]||0)+1;
    if(def){
      const linkedGroups=reportGroups.filter(rg=>rg.report_id===def.id)
        .map(rg=>groups.find(g=>g.id===rg.report_group_id)?.name).filter(Boolean);
      linkedGroups.forEach(g=>groupCounts[g]=(groupCounts[g]||0)+1);
    }
  });

  const buttonData=Object.keys(buttonCounts).map(k=>({button:`Button ${k}`,count:buttonCounts[k]}));
  const reportData=Object.keys(reportCounts).map(k=>({name:k,value:reportCounts[k]}));
  const groupData=Object.keys(groupCounts).map(k=>({name:k,value:groupCounts[k]}));
  const COLORS=["#8884d8","#82ca9d","#ffc658","#ff7f50","#a4de6c","#d0ed57"];

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Live Dashboard</h2>

      {/* Alerts */}
      {events.filter(e=>!e.processed).length>0 &&
        <div className="mb-4 p-4 bg-red-100 rounded">
          {events.filter(e=>!e.processed).length} unprocessed events
        </div>
      }

      {/* Charts */}
      <div className="flex flex-wrap gap-6 mb-6">
        <div className="border rounded shadow p-4 w-full md:w-1/3">
          <h3 className="font-semibold mb-2">Button Press Frequency</h3>
          <BarChart width={300} height={250} data={buttonData}>
            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis dataKey="button"/>
            <YAxis/>
            <Tooltip/>
            <Bar dataKey="count" fill="#8884d8"/>
          </BarChart>
        </div>
        <div className="border rounded shadow p-4 w-full md:w-1/3">
          <h3 className="font-semibold mb-2">Reports Triggered</h3>
          <PieChart width={300} height={250}>
            <Pie data={reportData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
              {reportData.map((entry,index)=><Cell key={index} fill={COLORS[index % COLORS.length]}/>)}
            </Pie>
            <Tooltip/>
          </PieChart>
        </div>
        <div className="border rounded shadow p-4 w-full md:w-1/3">
          <h3 className="font-semibold mb-2">Reports per Group</h3>
          <PieChart width={300} height={250}>
            <Pie data={groupData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
              {groupData.map((entry,index)=><Cell key={index} fill={COLORS[index % COLORS.length]}/>)}
            </Pie>
            <Tooltip/>
          </PieChart>
        </div>
      </div>
    </div>
  );
}
